var map = {
	"./bunny_borg_logo_factory.png": 451,
	"./bunny_borg_logo_hibernation.png": 526,
	"./bunny_borg_logo_no_bg.png": 680,
	"./bunny_borg_logo_seedwhisker.png": 909,
	"./bunny_borg_logo_shaman.png": 499,
	"./bunny_borg_logo_soulless.png": 303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;